<template>
  <div class="card-pos">
    <div class="card">
        <div class="card-body h-100">
            <img 
              class="card-img-top mt-3 cursor-pointer" 
              :src="imagesFile.preview" 
              img-alt="Image" 
              height="150" 
              @click="showModalImages(imagesFile.preview, imagesFile.name)"
            />
        </div>
        <div class="card-footer">
            <div class="card-text text-truncate-2">
                {{imagesFile.name}}
            </div>
            <div class="text-right">
              <button class="btn btn-sm btn-outline-secondary" @click="$emit('deleteImage')">
                <i class="fas fa-trash-alt fa-xs text-muted"></i>
              </button>   
            </div>
        </div>
    </div>
    <ModalImages :data="dataModalImages" />
  </div>
</template>
<script>
import ModalImages from '@/components/Modals/Modal-images'
export default {
  name: "BranceCardImage",
  props:{
    imagesFile: Object
  },
  components:{
    ModalImages
  },
  data(){
    return{
      dataModalImages:{
        show:false,
        img:false,
        name:"img"
      },
    }
  },
  methods:{
    showModalImages( img , name ){
      this.dataModalImages.show = true
      this.dataModalImages.img = img
      this.dataModalImages.name = name
    },
  }
};
</script>
